export const validateMessages = {
    required: '${label} es un campo requerido.',
    types: {
        email: '${label} is not validate email!',
    },
};
